import { lazy, Suspense } from "react";
import { RouteObject, useParams } from "../../helpers/tixxt-router";
import Loading from "../shared/Loading";

const ChannelsPage = lazy(() => import("./ChannelsPage"));
const FocusLabelsManagerPage = lazy(
  () => import("../focusLabels/FocusLabelsManagerPage"),
);
const BlogSourcesPage = lazy(() => import("./blogSources/BlogSourcesPage"));

function Params({ children }) {
  const params = useParams();
  return children(params);
}
const ChannelPage = lazy(() => import("./ChannelPage"));
const ShowWidgetPage = lazy(() => import("./widgets/ShowWidgetPage"));
const ChannelNewPage = lazy(() => import("./ChannelNewPage"));
const ChannelEditPage = lazy(() => import("./ChannelEditPage"));
const EditLayoutPage = lazy(() => import("./layout/EditLayoutPage"));
const EditDesignPage = lazy(() => import("./design/EditDesignPage"));
const WidgetsPage = lazy(() => import("./widgets/WidgetsPage"));
const NewWidgetPage = lazy(() => import("./widgets/NewWidgetPage"));
const EditWidgetPage = lazy(() => import("./widgets/EditWidgetPage"));

const channelRoutes: RouteObject[] = [
  {
    path: "/channels",
    element: (
      <Suspense fallback={<Loading />}>
        <ChannelsPage />
      </Suspense>
    ),
  },
  {
    path: "/channels/new",
    element: (
      <Suspense fallback={<Loading />}>
        <ChannelNewPage />
      </Suspense>
    ),
  },
  {
    path: "/channels/:channelSlug/edit",
    element: (
      <Suspense fallback={<Loading />}>
        <ChannelEditPage />
      </Suspense>
    ),
  },
  {
    path: "/channels/:channelSlug",
    element: (
      <Suspense fallback={<Loading />}>
        <ChannelPage />
      </Suspense>
    ),
  },
  {
    path: "/channels/:channelSlug/administration",
    element: (
      <Suspense fallback={<Loading />}>
        <ChannelPage isAdministration />
      </Suspense>
    ),
  },
  {
    path: "/channels/:channelSlug/administration/blog_sources",
    element: (
      <Suspense fallback={<Loading />}>
        <BlogSourcesPage />
      </Suspense>
    ),
  },
  {
    path: "/channels/:channelSlug/administration/focus_labels",
    element: (
      <Suspense fallback={<Loading />}>
        <Params>
          {({ channelSlug }) => (
            <FocusLabelsManagerPage parent={{ type: "channel", channelSlug }} />
          )}
        </Params>
      </Suspense>
    ),
  },
  {
    path: "/channels/:channelSlug/layout/edit",
    element: (
      <Suspense fallback={<Loading />}>
        <EditLayoutPage />
      </Suspense>
    ),
  },
  {
    path: "/channels/:channelSlug/design/edit",
    element: (
      <Suspense fallback={<Loading />}>
        <EditDesignPage />
      </Suspense>
    ),
  },
  {
    path: "/channels/:channelSlug/widgets",
    element: (
      <Suspense fallback={<Loading />}>
        <WidgetsPage />
      </Suspense>
    ),
  },
  {
    path: "/channels/:channelSlug/widgets/new",
    element: (
      <Suspense fallback={<Loading />}>
        <NewWidgetPage />
      </Suspense>
    ),
  },
  {
    path: "/channels/:channelSlug/widgets/:widgetId/edit",
    element: (
      <Suspense fallback={<Loading />}>
        <EditWidgetPage />
      </Suspense>
    ),
  },
  {
    path: "/channels/:channelSlug/widgets/:widgetId",
    element: (
      <Suspense fallback={<Loading />}>
        <ShowWidgetPage />
      </Suspense>
    ),
  },
];

export default channelRoutes;
